module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": 'canvas-hashrate-dari-' + _vm.avg
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b127c28","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/hashrate-dari.vue
// module id = 530
// module chunks = 1